<template>
  <v-snackbar
    v-if="visible"
    :value="true"
    :timeout="0"
    top
    color="grey darken-3"
    class="WebVersionTips"
  >
    <div
      class="WebVersionTips__body"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <div class="WebVersionTips__text">
        <div class="WebVersionTips__title">
          目前版本過舊，請更新後再繼續操作
        </div>
        <div class="WebVersionTips__description">
          若未完成更新，請關閉並重新開啟 App；使用瀏覽器時，請重新整理頁面。
        </div>
      </div>
      <button
        type="button"
        class="WebVersionTips__close"
        aria-label="關閉版本提示"
        @click="close"
      >
        <v-icon
          size="20"
          color="white"
          aria-hidden="true"
        >
          close
        </v-icon>
      </button>
    </div>
  </v-snackbar>
</template>

<script>
export default {
  name: 'WebVersionTips',
  computed: {
    visible () {
      return this.$store.state.webVersionOutdated && !this.$store.state.maintenance
    },
  },
  methods: {
    close () {
      this.$store.commit('setWebVersionOutdated', false)
    },
  },
}
</script>

<style lang="postcss">
.WebVersionTips .v-snack__wrapper {
  width: calc(100% - 32px);
  min-width: 0;
  max-width: 560px;
  margin: 24px auto 0;
  margin-top: calc(24px + env(safe-area-inset-top, 0px));
  border-radius: 6px;
}

.WebVersionTips .v-snack__content {
  height: auto;
  padding: 12px 16px;
  color: #fff;
  line-height: 1.5;
}

.WebVersionTips__title {
  font-size: 15px;
  font-weight: 600;
}

.WebVersionTips__body {
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.WebVersionTips__text {
  flex: 1;
  min-width: 0;
}

.WebVersionTips__close {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  margin: -10px -8px 0 8px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #fff;
  cursor: pointer;
}

.WebVersionTips__close:hover {
  background: rgba(255, 255, 255, 0.1);
}

.WebVersionTips__close:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

.WebVersionTips__description {
  margin-top: 4px;
  font-size: 13px;
}
</style>
